import { ORDER } from '@arpeggi/shared'
import { FC } from 'react'
import { useArpTableContext } from '.'
import { ChevronDown, ChevronUp } from '../../../__legacy__/components/core/icons'
import { ArpMediaFilters } from '../hooks'
import { Headers as HeadersPrimitive } from '../primitives'

const Root = HeadersPrimitive.Root

type OrderBy = ArpMediaFilters['orderBy']

const useOrder = (value: OrderBy) => {
  const { filters, updateFilters } = useArpTableContext()
  const { orderBy, order } = filters
  const isActive = orderBy === value
  const handleClick = () => {
    if (!isActive) return updateFilters({ order: 'asc', orderBy: value })
    updateFilters({ order: order === 'asc' ? 'desc' : 'asc' })
  }
  return { isActive, order, handleClick }
}

const Icon: FC<{ order: ORDER }> = ({ order }) => (
  <HeadersPrimitive.Icon as={order === 'desc' ? ChevronDown : ChevronUp} />
)

const Title: FC = () => {
  const { isActive, order, handleClick } = useOrder('title')
  return (
    <HeadersPrimitive.Column layout="main" active={isActive} onClick={handleClick} clickable>
      TITLE
      {isActive && <Icon order={order} />}
    </HeadersPrimitive.Column>
  )
}

const UnsortableTitle: FC = () => (
  <HeadersPrimitive.Column layout="main">TITLE</HeadersPrimitive.Column>
)

const Tags: FC = () => {
  return <HeadersPrimitive.Column layout="fluid2">DATA</HeadersPrimitive.Column>
}

const DateMinted: FC = () => {
  const { isActive, order, handleClick } = useOrder('mintedAt')
  return (
    <HeadersPrimitive.Column layout="fluid1" active={isActive} onClick={handleClick} clickable>
      MINTED
      {isActive && <Icon order={order} />}
    </HeadersPrimitive.Column>
  )
}

const UnsortableDateMinted: FC = () => (
  <HeadersPrimitive.Column layout="fluid1">MINTED</HeadersPrimitive.Column>
)

const Favorite: FC = () => {
  const { isActive, order, handleClick } = useOrder('favoriteCount')
  return (
    <HeadersPrimitive.Column layout="fluid1" active={isActive} onClick={handleClick} clickable>
      LIKES
      {isActive && <Icon order={order} />}
    </HeadersPrimitive.Column>
  )
}

const UnsortableFavorite: FC = () => (
  <HeadersPrimitive.Column layout="fluid1">LIKES</HeadersPrimitive.Column>
)

const Remixes: FC = () => {
  const { isActive, order, handleClick } = useOrder('remixCount')
  return (
    <HeadersPrimitive.Column layout="fluid1" active={isActive} onClick={handleClick} clickable>
      REMIXES
      {isActive && <Icon order={order} />}
    </HeadersPrimitive.Column>
  )
}

const UnsortableRemixes: FC = () => (
  <HeadersPrimitive.Column layout="fluid1">REMIXES</HeadersPrimitive.Column>
)

const Plays: FC = () => {
  const { isActive, order, handleClick } = useOrder('playCount')
  return (
    <HeadersPrimitive.Column layout="fluid1" active={isActive} onClick={handleClick} clickable>
      PLAYS
      {isActive && <Icon order={order} />}
    </HeadersPrimitive.Column>
  )
}

const UnsortablePlays: FC = () => (
  <HeadersPrimitive.Column layout="fluid1">PLAYS</HeadersPrimitive.Column>
)

const Duration: FC = () => {
  const { isActive, order, handleClick } = useOrder('durationMs')
  return (
    <HeadersPrimitive.Column layout="fluid1" active={isActive} onClick={handleClick} clickable>
      TIME
      {isActive && <Icon order={order} />}
    </HeadersPrimitive.Column>
  )
}

const UnsortableDuration: FC = () => (
  <HeadersPrimitive.Column layout="fluid1">PLAYS</HeadersPrimitive.Column>
)

export const Headers = {
  Root,
  Title,
  Tags,
  DateMinted,
  Favorite,
  Remixes,
  Plays,
  Duration,
  UnsortableTitle,
  UnsortableDateMinted,
  UnsortableFavorite,
  UnsortableRemixes,
  UnsortablePlays,
  UnsortableDuration
}
